import "../../assets/css/login.css?v=11";
import React, { useState } from "react";

const AuthLayout = ({ children, InitialLoading = false }) => {

  const [loading, setLoading] = useState(InitialLoading); // Loader State

  return (
    <div className="auth-layout">
      {loading && (
        <div className="loader-main">
          <div className="loader">
            <span></span>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

export default AuthLayout;
